<template src="./MedicalRecords.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showWebTable: true,
      medicalRecords: [],
      medicalRecordsCache: [],
      idMedicalRecord: 0
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records?size=50,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },

          }
        )
        .then(function(response) {
          if(response.status === 200){
            vm.medicalRecords = response.data.content.filter( m => m.status.type !== 'PENDENT' );
            for (const mr of vm.medicalRecords) {
              mr.patientName = mr.patient.name;
            }
          }

        });
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 740) {
        vm.showWebTable = false;
      } else {
        vm.showWebTable = true;
      }
    },
    handleSearch(search) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(search)) {
        vm.medicalRecords = vm.medicalRecordsCache;
      } else {
        vm.medicalRecords = vm.medicalRecordsCache.filter(mr => mr.patient.name.includes(search));
      }
    },
    downloadMedicalRecords(idMedicalRecord) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            idMedicalRecord +
            "/download-token",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          window.open(
            vm.$store.state.filooServer +
              "/medical-records/" +
              idMedicalRecord +
              "/complete/download/" +
              response.data.token
          );

        });
    }
  }
};
</script>

<style lang="scss" src="./MedicalRecords.scss">
</style>
